import React from "react";
import Navigation from "../Navigation/Navigation";
import { MdKeyboardArrowLeft, MdEast, MdDelete } from "react-icons/md";
import {
  Image,
  Container,
  Col,
  Row,
  Button,
  InputGroup,
} from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Local1 from "../../assets/local-1.png";

const Checkout = (props) => {
  return (
    <>
      <div className="gray-bg">
        <div className="navbar-section p-0">
          <Navigation />
        </div>
        <div className="main-content pt-5 pr-3 pb-4">
          <p className="page-text dashboard">
            <Link>
              <MdKeyboardArrowLeft className="arrow-left" />
              Back
            </Link>
          </p>
          <p className="page-maintitle">Checkout</p>
          <Row className="main-checkout mt-4">
            <Col md="6">
              <p className="checkout-title">Checkout (1 Item)</p>
              <p>Please fill out the billing information</p>
              <p className="checkout-method mt-4">Payment method</p>
              <Form className="passwordcheck mt-4 orange-check">
                <Form.Check
                  name="grouped"
                  required
                  inline
                  label="Credit/Debit Card"
                  type="radio"
                  isValid
                />
                <br />
                <div className="inner-checkout">
                  <Form.Check
                    name="grouped"
                    required
                    inline
                    label="**** **** 9755"
                    type="radio"
                    isValid
                  ></Form.Check>
                  <br />
                  <Form.Check
                    name="grouped"
                    required
                    inline
                    label="**** **** 1243"
                    type="radio"
                    isValid
                  />
                  <br />
                  <Link to="/addnewcard">
                    <p className="addnew-card">+ Add new card</p>
                  </Link>
                </div>
                <Form.Check
                  name="grouped"
                  required
                  inline
                  label="PayPal"
                  type="radio"
                  isValid
                />
                <br />
                <Form.Check
                  name="grouped"
                  required
                  inline
                  label="Google Pay"
                  type="radio"
                  isValid
                />
              </Form>
              <p className="checkout-method mt-4">Your Item</p>
              <Row className="local-main">
                <Col md="2" className="local-1">
                  <Image loading="lazy" src={Local1} />
                </Col>
                <Col>
                  <p className="loc-detail-1">Beauty & Spa</p>
                  <p className="loc-detail-2">
                    Up tp 15% OFF on Beauty Products
                  </p>
                  <p className="loc-detail-3">by Bijou Lash Extensions</p>
                  <div className="d-flex">
                    <p className="loc-price-1">$45</p>
                    <p className="loc-price-2">$27</p>
                    <p className="you-save">You save $18</p>
                  </div>
                </Col>
                <div className="tag-main">
                  <p className="ribben">VOUCHER</p>
                </div>
              </Row>
            </Col>
            <Col md="4">
              <p className="checkout-title">Order Summary</p>
              <div className="price-main mt-3">
                <div className="d-flex price-inner">
                  <p>Subtotal :</p>
                  <p>$27</p>
                </div>
                <hr />
                <div className="d-flex price-inner">
                  <p>
                    <b>Tax:</b>
                  </p>
                  <p>
                    <b>$00</b>
                  </p>
                </div>
                <div className="d-flex price-inner">
                  <p>
                    <b>Order Total:</b>
                  </p>
                  <p>
                    <b>$27</b>
                  </p>
                </div>
                <Button
                  variant="primary"
                  type="submit"
                  className="green-btn mt-3"
                >
                  Sign In
                </Button>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default Checkout;
